import type { AnimationGroup } from "@babylonjs/core/Animations/animationGroup";
import clips from "../../../assets/models-src/npcs/kitten_anim.json";
import { GroundedNpcGait } from "./GroundedNpcGait";

export type KittenGait = GroundedNpcGait;
export const KittenGait = {
  create(groups: readonly AnimationGroup[], scale: number): KittenGait | null {
    return GroundedNpcGait.create(groups, scale, clips.clips);
  },
};
